module.exports = __webpack_public_path__ + "static/media/DT_bubak.0ed4b4b3.png";